import { css } from '@emotion/react';
import type { ScheduleActivityItem } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/schedule_activity.pb';
import { useGetAppointmentColorsEnabled } from '@frontend/schedule-helpers';
import { Dot, Text, Truncated } from '@frontend/design-system';

type Props = {
  row: ScheduleActivityItem;
  isService?: boolean;
};

export const ServiceAndAppointmentTypeCellRenderer = ({ row, isService }: Props) => {
  const { canUseAppointmentColors } = useGetAppointmentColorsEnabled();

  if ((isService && !row?.service?.displayName) || (!isService && !row?.appointmentType?.displayName)) {
    return <Text size='medium'>-</Text>;
  }

  const displayName = isService ? row?.service?.displayName : row?.appointmentType?.displayName;
  const displayColor = isService ? null : row?.appointmentType?.color;

  return (
    <div css={containerStyles}>
      {canUseAppointmentColors && displayColor && (
        <Dot color='warning' css={[{ background: displayColor }, dotStyles]} />
      )}
      <Truncated as={Text} size='medium' weight='bold'>
        {displayName}
      </Truncated>
    </div>
  );
};

const containerStyles = css`
  width: 100%;
  display: flex;
  align-items: center;
  gap: var(--fabric-space-gap-xxs);
`;

const dotStyles = css`
  border: none;
  position: relative;
  min-width: 16px;
`;
